import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { fetchAdvertiserList, fetchAdvertiserInfo } from '@/api/advertiser/manage.ts';
import TableList from '@/components/TableList/index.vue';
import { AdvertiserAccountTypeLabel } from '@/common/permission';

export default {
  components: {
    TableList: TableList
  },
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },

  data: function data() {
    return {
      advertiser: {},
      // 广告主账单信息列表
      invoicesList: [],
      advertiserList: [],
      invoiceTipsMsg: '\uFF01\u4E3A\u4E86\u907F\u514D\u540E\u7EED\u8D26\u5355\u51FA\u8D26\u5931\u8D25\uFF0C\u5145\u503C\u6D88\u8017\u5957\u9910\u8BF7\u4F7F\u7528\u4E13\u7528\u7684invoice name\u3002 \uFF083s\u9650\u5236\uFF1A\u4E00\u4E2Ausername\u5728\u4E00\u4E2A\u6708\u5185\u53EA\u80FD\u7ED9\u4E00\u4E2Ainvoice id\u5F00\u4E00\u5F20\u7968\uFF09\u3002'
    };
  },


  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: 'Invoice name',
        prop: 'name'
      }, {
        label: 'Name Of Business',
        prop: 'company'
      }, {
        label: 'Address',
        prop: 'address'
      }, {
        slot: 'choose-slot'
      }];
    },
    accountTypeLabel: function accountTypeLabel() {
      return AdvertiserAccountTypeLabel[this.advertiser.mws_account_type] || '';
    }
  },

  watch: {
    'formValue.adv_id': function formValueAdv_id(val) {
      if (val) {
        this.getAdvInvoices(val);
      } else {
        this.reset();
      }
    }
  },

  methods: {
    getAdvInvoices: function getAdvInvoices(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchAdvertiserInfo({
                  id: id
                });

              case 3:
                res = _context.sent;

                _this.advertiser = _.get(res, 'data.data.info');
                _this.invoicesList = _.get(res, 'data.data.info.invoices') || [];

                // eslint-disable-next-line vue/no-mutating-props
                _this.formValue.mws_account_type = _this.advertiser.mws_account_type;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getAdvertiserList: function getAdvertiserList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchAdvertiserList(params);

              case 2:
                res = _context2.sent;

                _this2.advertiserList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    value: item.id,
                    label: item.name
                  });
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reset: function reset() {
      this.invoicesList = [];
      this.advertiser = {};
    }
  },

  created: function created() {
    // if (this.authorizeInfo.adv_id) {
    //   this.getAdvInvoices(this.authorizeInfo.adv_id)
    //   this.getAdvertiserList(
    //     this.authorizeInfo.adv_id
    //       ? { keyword: this.authorizeInfo.adv_id, search_field: 'id' }
    //       : {},
    //   )
    // }
  }
};